import { ICON_HEIGHT_16 } from '../../Icon'
import { getTaskIconByApiName } from '../../Task'
import { ListItem } from '../ListItem'

function TypeListItem({ value: { icon, name }, ...restProps }) {
  return (
    <ListItem
      {...restProps}
      ListIcon={getTaskIconByApiName(icon.name)}
      avatarProps={{ iconSize: ICON_HEIGHT_16 }}
      text={name}
    />
  )
}

export default TypeListItem
